import React, { Component } from "react";

import {
  Table,
  Button,
  Divider,
  Card,
  Form,
  Input,
  Modal,
  message
} from "antd";

import api from "../../services/api";

export default class Pessoas extends Component {
  state = {
    tableLoading: true,
    dataSource: [],
    total: 0
  };

  page = 1;
  search = "";

  componentDidMount = async () => {
    let data = await this.getPessoas("");
    console.log("aqui");
    let dataSource = this.handleAPIResponse(data);
    console.log("aqui");
    this.setState({
      tableLoading: false,
      dataSource: dataSource,
      total: data.data.count
    });
    console.log(this.state);
  };

  getPessoas = async () => {
    try {
      let res = await api(`/pessoa/?search=${this.search}&page=${this.page}`);
      console.log(res);
      return res;
    } catch (err) {
      window.alert("erro");
    }
  };

  handleAPIResponse = res => {
    let dataSource = [];

    res.data.results.forEach((defaultValue, index) => {
      dataSource.push({
        id: defaultValue.id,
        renda_assertiva: defaultValue.renda_assertiva,
        renda_intouch: defaultValue.renda_intouch,
        dt_nasc: defaultValue.dt_nasc,
        cnpj_empresa: defaultValue.cnpj_empresa,
        porcentagem_empresa: defaultValue.porcentagem_empresa,
        porte_empresa: defaultValue.porte_empresa,
        nome: defaultValue.nome,
        cpf_cnpj: defaultValue.cpf_cnpj,
        id_pipedrive: defaultValue.id_pipedrive,
        id_pipedrive_org: defaultValue.id_pipedrive_org,
        key: index
      });
    });
    return dataSource;
  };

  columns = [
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome"
    },
    {
      title: "CPF/CNPJ",
      dataIndex: "cpf_cnpj",
      key: "cpf_cnpj"
    },
    {
      title: "ID Pipedrive",
      dataIndex: "id_pipedrive",
      key: "id_pipedrive"
    },
    {
      title: "ID Pipedrive (Organização)",
      dataIndex: "id_pipedrive_org",
      key: "id_pipedrive_org"
    },
    {
      title: "Ações",
      key: "actions",
      render: (text, record) => (
        <span>
          <Button
            onClick={event => this.handleViewPerson(record)}
            type="primary"
            icon="eye"
          />
          <Divider type="vertical" />
          <Button
            onClick={event => this.handleEditPerson(record)}
            icon="edit"
          />
        </span>
      )
    }
  ];

  handleViewPerson = record => {
    this.setState({
      ...this.state,
      pessoa: record,
      visible: true,
      disabled: true
    });
  };
  handleEditPerson = record => {
    this.setState({
      ...this.state,
      pessoa: record,
      visible: true,
      disabled: false
    });
  };

  handleOnClick = async e => {
    //e.preventDefault()
    this.setState({ ...this.state, tableLoading: true });
    const search = document.getElementById("search").defaultValue;
    this.search = search;
    let data = await this.getPessoas();
    let dataSource = this.handleAPIResponse(data);
    this.setState({
      tableLoading: false,
      dataSource: dataSource,
      total: data.data.count
    });
  };

  onChange = async e => {
    this.setState({ ...this.state, tableLoading: true });
    this.page = e;
    let data = await this.getPessoas();
    let dataSource = this.handleAPIResponse(data);
    this.setState({
      tableLoading: false,
      dataSource: dataSource,
      total: data.data.count
    });
  };

  render() {
    const modal = this.state.visible == true ? this.getModal() : "";

    return (
      <div>
        <Card title="Pessoas" style={{ marginTop: "2.5%" }}>
          <Card>
            <Input
              type="text"
              id="search"
              style={{ width: "80%" }}
              placeholder="Pasta/Nome/CPF/CNPJ/ID Pipedrive/ID Pipedrive (Organização)"
            />
            <Button
              onClick={this.handleOnClick}
              type="primary"
              style={{ width: "15%", marginLeft: "5%" }}
            >
              Pesquisar
            </Button>
          </Card>
          <Card style={{ marginTop: "30px" }}>
            <Table
              columns={this.columns}
              dataSource={this.state.dataSource}
              loading={this.state.tableLoading}
              pagination={{
                total: this.state.total,
                pageSize: 1000,
                onChange: e => this.onChange(e)
              }}
            />
          </Card>
        </Card>
        {modal}
      </div>
    );
  }

  handleCloseModal = e => {
    this.setState({ visible: false });
  };

  handleOnSubmit = async e => {
    e.preventDefault();
    let params = {
      id: this.state.pessoa.id,
      nome: document.getElementById("nome").value,
      cpf_cnpj: document.getElementById("cpf_cnpj").value,
      renda_assertiva: document.getElementById("renda_assertiva").value,
      renda_intouch: document.getElementById("renda_intouch").value,
      cnpj_empresa: document.getElementById("cnpj_empresa").value,
      porcentagem_empresa: document.getElementById("porcentagem_empresa").value,
      id_pipedrive: document.getElementById("id_pipedrive").value,
      id_pipedrive_org: document.getElementById("id_pipedrive_org").value
    };
    if (params.renda_assertiva == "") delete params["renda_assertiva"];
    if (params.renda_intouch == "") delete params["renda_intouch"];
    if (params.porcentagem_empresa == "") delete params["porcentagem_empresa"];
    try {
      const res = await api.put(`/pessoa/${this.state.pessoa.id}/`, params, {
        headers: { "content-type": "application/json" }
      });
      message.success("Pessoa atualizada com sucesso");
    } catch (err) {
      message.error("Houve um erro :(");
      console.log(err);
    }

    this.setState({
      ...this.state,
      visible: false
    });
  };

  getModal() {
    const pessoa = this.state.pessoa;
    console.log(pessoa);
    return (
      <Modal
        title="Pessoa"
        visible={this.state.visible}
        closabe={true}
        destroyOnClose={true}
        onCancel={this.handleCloseModal}
        afterClose={this.handleCloseModal}
        footer={[]}
      >
        <Card>
          <Form onSubmit={e => this.handleOnSubmit(e)}>
            <Form.Item label="Nome">
              <Input
                placeholder="Nome"
                disabled={this.state.disabled}
                id="nome"
                defaultValue={pessoa.nome == null ? "" : pessoa.nome}
              />
            </Form.Item>
            <Form.Item label="CPF/CNPJ">
              <Input
                placeholder="cpf/cnpj"
                disabled={this.state.disabled}
                id="cpf_cnpj"
                defaultValue={pessoa.cpf_cnpj == null ? "" : pessoa.cpf_cnpj}
              />
            </Form.Item>
            <Form.Item label="Renda Assertiva">
              <Input
                placeholder="Renda Assertiva"
                type="number"
                disabled={this.state.disabled}
                id="renda_assertiva"
                defaultValue={
                  pessoa.renda_assertiva == null ? "" : pessoa.renda_assertiva
                }
              />
            </Form.Item>
            <Form.Item label="Renda Intouch">
              <Input
                placeholder="Renda Intouch"
                type="number"
                disabled={this.state.disabled}
                id="renda_intouch"
                defaultValue={
                  pessoa.renda_intouch == null ? "" : pessoa.renda_intouch
                }
              />
            </Form.Item>
            <Form.Item label="CNPJ da Empresa">
              <Input
                placeholder="CNPJ da Empresa"
                disabled={this.state.disabled}
                id="cnpj_empresa"
                defaultValue={
                  pessoa.cnpj_empresa == null ? "" : pessoa.cnpj_empresa
                }
              />
            </Form.Item>
            <Form.Item label="Participacao na empresa">
              <Input
                placeholder="Participacao na empresa"
                disabled={this.state.disabled}
                id="porcentagem_empresa"
                defaultValue={
                  pessoa.porcentagem_empresa == null
                    ? ""
                    : pessoa.porcentagem_empresa
                }
              />
            </Form.Item>
            <Form.Item label="ID Pipedrive">
              <Input
                placeholder="ID Pipedrive"
                type="number"
                disabled={this.state.disabled}
                id="id_pipedrive"
                defaultValue={
                  pessoa.id_pipedrive == null ? "" : pessoa.id_pipedrive
                }
              />
            </Form.Item>
            <Form.Item label="ID Pipedrive (Organização)">
              <Input
                placeholder="ID Pipedrive (Organização)"
                type="number"
                disabled={this.state.disabled}
                id="id_pipedrive_org"
                defaultValue={
                  pessoa.id_pipedrive_org == null ? "" : pessoa.id_pipedrive_org
                }
              />
            </Form.Item>
            <Button
              htmlType="submit"
              type="primary"
              disabled={this.state.disabled}
            >
              Salvar
            </Button>
          </Form>
        </Card>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Pessoas/index.js